"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = compareRangeLists;

var _deepEqual = _interopRequireDefault(require("deep-equal"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function compareRangeLists(t1, t2) {
  if (!t1 !== !t2) return false;

  if (Array.isArray(t1) && Array.isArray(t2)) {
    if (t1.length !== t2.length) return false;
    return (0, _deepEqual["default"])((0, _lodash.last)(t1), (0, _lodash.last)(t2));
  }

  return (0, _deepEqual["default"])(t1, t2);
}